export default [
  {
    path: '/financeiro/relatorios',
    name: 'financeirorelatorios',
    component: () => import('@/app-modulo/comercial/FinanceiroRelatorios/Lista/FinanceiroRelatorios.vue'),
    meta: {
      resource: 'parametrizacaogeral',
      action: 'read',
      pageTitle: 'Relatório Financeiro',
      breadcrumb: [],
    },
  },
]
